'use strict';

var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');

module.exports = {
    getDealers: function () {
        $('body').on('stores:getDealers', function (e, data) {
            // generic function to get dealers list details
        });
    },

    updateLocationWithPortDealer: function () {
        $('body').on('stores:updateLocationWithPortDealer', function (e, data) {
            if (data.portId && data.dealerId) {
                let userLocation = JSON.parse(frontendUtils.getCookie('userloc') || 'null');

                if (userLocation) {
                    const updatedLocation = { ...userLocation, dealer: data };
                    frontendUtils.setCookie(
                        'userloc',
                        JSON.stringify(updatedLocation)
                    );

                    $('body').trigger('stores:updateLocationWithPortDealer:afterUpdate');
                }
            }
        });
    }
};
